<div class="body" #body>
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>